module.exports = __webpack_public_path__ + "static/img/5.ef6a5a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_icon/5.png
// module id = hVzj
// module chunks = 1